export const CHAPTER_COUNT = 5;

export function chapterFromProgress(p: number): number {
  const clamped = Math.max(0, Math.min(1, p));
  return Math.min(CHAPTER_COUNT - 1, Math.floor(clamped * CHAPTER_COUNT));
}

export function easeInOutCubic(t: number): number {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}
